import videojs from 'video.js';

import logger from '@src/utils/logger';

export const getDebugFlags = () => {
  if (typeof window === 'undefined') return;

  try {
    const debugFlags =
      new URL(window?.location?.href)?.searchParams
        ?.get?.('01debug')
        ?.split(',') ?? [];

    return debugFlags;
  } catch (err) {
    logger.error(err, `Fail to parse debug flags from request URL`);
  }
};

export const detectDebugHelper = () => {
  if (getDebugFlags()?.includes('vdoplayer')) {
    videojs.log.level('debug');
  }
};
